import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const SkeletonsTable = ({ rows = 6 }) => {
    return (
        <>
            {[...Array(rows)].map((_, index) => (
                <tr key={index}>
                    <td>
                        <Skeleton variant="text" width={10} />
                        <Skeleton variant="text" width={50} />
                    </td>

                    <td>
                        <Skeleton variant="text" width={80} />
                        <Skeleton variant="text" width={100} />
                    </td>

                    <td>
                        <Skeleton variant="text" width={190} />
                        <Skeleton variant="text" width={90} />
                    </td>

                    <td>
                        <Skeleton variant="text" width={190} />
                        <Skeleton variant="text" width={70} />
                        <Skeleton variant="text" width={130} />
                    </td>

                    <td className="text-center">
                        <Skeleton
                            variant="text"
                            width={110}
                            className="mx-auto"
                        />
                    </td>

                    <td className="text-center">
                        <Skeleton
                            variant="text"
                            width={90}
                            className="mx-auto"
                        />
                    </td>

                    <td className="text-center">
                        <Skeleton
                            variant="text"
                            width={100}
                            className="mx-auto"
                        />
                    </td>

                    <td className="text-center" style={{ minWidth: '140px' }}>
                        <Skeleton
                            variant="text"
                            width={90}
                            className="mx-auto"
                        />
                    </td>

                    <td className="text-center">
                        <Skeleton
                            variant="rounded"
                            width={8}
                            height={20}
                            className="mx-auto"
                        />
                    </td>
                </tr>
            ))}
        </>
    );
};

export default SkeletonsTable;
